import script from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPage.vue?vue&type=script&setup=true&lang=js"

import "./ErrorPage.vue?vue&type=style&index=0&id=159db0e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159db0e4"]])

export default __exports__